var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "card card-separator mb-2 clickable",
      on: { click: _vm.toggleCollapse },
    },
    [
      _c("div", { staticClass: "card-header px-3 py-2 bb-0" }, [
        _c("div", { staticClass: "row align-items-end" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 d-flex justify-content-between align-items-center",
            },
            [
              _c("div", [
                _vm.boardLevel === "board"
                  ? _c(
                      "h2",
                      {
                        staticClass:
                          "section-separator-title automation-separator-title-big",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.triggerTitle.replace(
                                _vm.triggerTitle.split(" ").pop(),
                                ""
                              )
                            ) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "section-separator-title-status",
                            style: _vm.textColor,
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.triggerTitle.split(" ").pop()) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _c(
                      "h2",
                      {
                        staticClass:
                          "section-separator-title automation-separator-title-big text-primary",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.triggerTitle) +
                            "\n          "
                        ),
                      ]
                    ),
                _vm._v(" "),
                _c(
                  "h3",
                  {
                    staticClass:
                      "section-separator-title separator-subtitle text-uppercase",
                    style: _vm.subtitleColor,
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.triggerSubtitle) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "popoverContainer",
                  staticClass: "popover-container",
                  staticStyle: { position: "absolute", right: "30px" },
                },
                [
                  _vm.trigger["additional-info"]
                    ? _c(
                        "v-popover",
                        {
                          ref: "additionalInfoPopover",
                          attrs: {
                            placement: "left",
                            "boundaries-element": "popoverContainer",
                            trigger: "hover",
                            "auto-hide": true,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "popover",
                                fn: function () {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "additional-popover p-3" },
                                      [
                                        _c(
                                          "h5",
                                          {
                                            staticClass: "bold mb-2 text-grey",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "automations.applicationLevel.whenWillThisAutomationBeTriggered"
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("h6", {
                                          staticClass:
                                            "font-weight-normal text-grey",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.trigger["additional-info"]
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            1766846080
                          ),
                        },
                        [
                          _vm.trigger["additional-info"]
                            ? _c("i", {
                                staticClass:
                                  "fa fa-info-circle mr-2 clickable tooltip-target text-primary",
                                attrs: { "aria-hidden": "true" },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c("i", { staticClass: "text-primary", class: _vm.caretClass }),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }